/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Member } from './Member'
import { MemberFromJSON, MemberFromJSONTyped, MemberToJSON } from './Member'

/**
 *
 * @export
 * @interface AboutPageData
 */
export interface AboutPageData {
  /**
   *
   * @type {string}
   * @memberof AboutPageData
   */
  pageTitle: string
  /**
   *
   * @type {string}
   * @memberof AboutPageData
   */
  subPageTitle: string
  /**
   *
   * @type {Array<Member>}
   * @memberof AboutPageData
   */
  companyMembers: Array<Member>
}

/**
 * Check if a given object implements the AboutPageData interface.
 */
export function instanceOfAboutPageData(value: object): value is AboutPageData {
  if (!('pageTitle' in value) || value['pageTitle'] === undefined) return false
  if (!('subPageTitle' in value) || value['subPageTitle'] === undefined)
    return false
  if (!('companyMembers' in value) || value['companyMembers'] === undefined)
    return false
  return true
}

export function AboutPageDataFromJSON(json: any): AboutPageData {
  return AboutPageDataFromJSONTyped(json, false)
}

export function AboutPageDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AboutPageData {
  if (json == null) {
    return json
  }
  return {
    pageTitle: json['pageTitle'],
    subPageTitle: json['subPageTitle'],
    companyMembers: (json['companyMembers'] as Array<any>).map(MemberFromJSON),
  }
}

export function AboutPageDataToJSON(value?: AboutPageData | null): any {
  if (value == null) {
    return value
  }
  return {
    pageTitle: value['pageTitle'],
    subPageTitle: value['subPageTitle'],
    companyMembers: (value['companyMembers'] as Array<any>).map(MemberToJSON),
  }
}
